import { emailTypes } from "@enums/TemplatesEmail/Index";

const TipoEmail = ({ tipoEmail }) => {
  const tipo = emailTypes.find(item => item.value === tipoEmail);

  return <span>{tipo ? tipo.label : tipoEmail}</span>;
};

export default TipoEmail;
